import React, { useContext, useState } from "react";
import { PopupContext } from "../LoginPopup/LoginPopupContext";
import config from "../../config";

export default function BannerPopup() {
  const { isBannerOpend, setIsBannerOpen } = useContext(PopupContext);
  const getDesktopBanner = () => {
    let pubanner2 = config.pubObj;
    if (pubanner2.length > 0) {
      let asd = pubanner2[0];
      return asd?.bannerName;
    } else {
      return "";
    }
  }

  const getMobileBanner = () => {
    let pubanner2 = config.pubObj;
    if (pubanner2.length > 0) {
      let asd = pubanner2[1];
      return asd?.bannerName;
    } else {
      return "";
    }
  }

  const getImage = (type) =>{
    let pubanner2 = config.pubObj    
      if(pubanner2.length > 0){
        let asd = pubanner2.find(item=> item.title.toLowerCase().trim() == type.toLowerCase().trim());
        return asd?.bannerName;
      }else{
        return "";
      }
    }

  const checkIsShow = () => {
    let pubanner2 = config.pubObj
      if(pubanner2.length > 0){
        return true;
      }else{
        return false;
      }
  }
  return (
    <div className={`popup home-modal ${checkIsShow() && isBannerOpend ? "open" : ""}`}>
        <div className="popup-content">
          <div className="popup-body">
            <button class="close-home-modal" onClick={() => (setIsBannerOpen(false),config.bannerOpen = true,localStorage.setItem("bannerOpen",true))}>
            <i class="fas fa-times"></i>
          </button>
          <div className="img-set">
              <img className="mobile-hide" alt="" src={getDesktopBanner()} decoding="async" loading="lazy"/>
              <img className="desktop-hide" alt="" src={getMobileBanner()} decoding="async" loading="lazy"/>
          </div>
          </div>
        </div>

    </div>
  );
}
